// src/composables/useLogger.ts
import { inject } from 'vue';
import type { LoggerInstance } from './smartVConsole';

const fallbackLogger: LoggerInstance = {
  downloadLogs: () => undefined,
  clearLogs: () => undefined,
  getLogs: () => [],
  getLogCount: () => 0,
  addLog: () => undefined
};

export function useLogger(): LoggerInstance {
  const logger = inject<LoggerInstance>('logger', fallbackLogger);
  
  if (logger === fallbackLogger) {
    console.warn('Logger 未初始化，请确保已注册 SmartVConsole 插件');
  }
  
  return logger;
}
